/**
 * آیکونِ تب برای نسخه‌ی غیرِ پروداکشنِ سایت — نارنجی، همان رنگِ اپِ «WhosUp Dev»
 * روی گوشی (WHOSUP-225).
 *
 * ═══ چرا در زمانِ اجرا و نه در بیلد ═══
 *
 * استیجینگ و پروداکشن از یک بسته‌ی یکسان ساخته می‌شوند (شاخه‌ی `dev` و شاخه‌ی
 * اصلیِ همان پروژه‌ی Cloudflare Pages). اگر آیکون را موقعِ بیلد جاگذاری کنیم،
 * باید دو بیلدِ متفاوت داشته باشیم و بیلدی که تست شده دقیقاً همانی نباشد که
 * منتشر می‌شود. یک خط جاوااسکریپت در زمانِ اجرا این را ندارد، و مفتِ اضافه
 * `npm run web` روی لوکال را هم درست می‌کند.
 *
 * هزینه‌اش این است که تبِ استیجینگ کسری از ثانیه آیکونِ سرمه‌ای را نشان
 * می‌دهد و بعد نارنجی می‌شود. برای ابزارِ داخلی کاملاً قابلِ قبول است.
 *
 * ⚠️ فایل‌های `favicon-dev.*` را `npm run brand:assets` می‌سازد و
 * `npm run guard:assets` وجودشان را چک می‌کند — این‌جا فقط رشته‌ی مسیر است و
 * مرورگر دربارهٔ فاوآیکونِ ۴۰۴ کاملاً ساکت است.
 */
import { isProductionSiteHost } from '@/core/lib/siteEnv';

/** مسیرِ پروداکشن ← مسیرِ نسخه‌ی توسعه. کلیدها باید با index.html یکی باشند. */
export const DEV_ICON_PATHS: Readonly<Record<string, string>> = {
  '/favicon.ico': '/favicon-dev.ico',
  '/favicon.svg': '/favicon-dev.svg',
  '/apple-touch-icon.png': '/apple-touch-icon-dev.png',
};

export function applySiteIcon(hostname: string = window.location.hostname): void {
  if (isProductionSiteHost(hostname)) return;
  const links = document.querySelectorAll<HTMLLinkElement>(
    'link[rel~="icon"], link[rel="apple-touch-icon"]',
  );
  for (const link of links) {
    // `link.href` مطلق برمی‌گردد؛ چیزی که با جدولِ بالا تطبیق می‌شود مسیر است.
    const replacement = DEV_ICON_PATHS[new URL(link.href, location.origin).pathname];
    if (!replacement) continue;
    link.href = replacement;
    /**
     * عوض کردنِ `href` به‌تنهایی همیشه کافی نیست: بعضی مرورگرها فاوآیکون را
     * فقط وقتی دوباره می‌خوانند که خودِ گره در سند جابه‌جا شود. برداشتن و
     * گذاشتنِ دوباره‌ی همان گره ارزان‌ترین راهی است که همه‌جا جواب می‌دهد.
     */
    link.parentNode?.appendChild(link);
  }
}
